const mutations = {
  // 设置领取按钮状态
  muSetIsReceiveBtnDisabled(state, status) {
    state.isReceiveBtnDisabled = status;
  },
  // 设置领取状态
  muSetIsReceiveStatus(state, status) {
    state.isReceiveStatus = status;
  },
  // 设置上规格
  muSetUpSpecilId(state, id) {
    state.upSpecilId = id;
  },
  // 设置下规格
  muSetDownSpecilId(state, id) {
    state.downSpecilId = id;
  },
  muSetSkuId(state, id) {
    state.skuId = id;
  },
  // 是否多规格
  muSetIsSpecil(state, id) {
    state.isSpecil = id;
  }
};
export default mutations;
